<template>
<div :style="
          'height:' +
            height +
            'px'">
  <poster
          :src="src"
          :config="config"
          :promotionType="campaign.promotionType.promotionType"
          :height="height"
          :aspectRatio="aspectRatio">
  </poster>
  <!-- <v-img :src="src" :aspect-ratio="aspectRatio" :contain="contain" lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="></v-img> -->
</div>
</template>

<script>
import Poster from './webshop/CampaignPoster'
import imageTypes from '@/constants/image-types'

const ORIGINAL_IMAGE_POSTFIX = '_original'
// A lookup object for cloudinary folder and default image based on image type
var cloudinary = {}
cloudinary[imageTypes.Salon] = {
  typeFolder: 'department',
  defaultImage: 'd_defaults:d_department.jpg',
  id: function (id) {
    return id('department_' + id() + '_webbanner')
  }
}
cloudinary[imageTypes.Chain] = {
  typeFolder: 'chain',
  defaultImage: 'd_defaults:default_blank.png',
  id: function (id) {
    return id() + '_logo'
  }
}
cloudinary[imageTypes.Campaign] = {
  typeFolder: 'campaign',
  defaultImage: 'd_defaults:default_campaign_img_rinpae.png'
}
cloudinary[imageTypes.SupplierBrand] = {
  typeFolder: 'supplierBrand',
  defaultImage: 'd_defaults:d_brand.png'
}
cloudinary[imageTypes.SupplierSerie] = {
  typeFolder: 'supplierSerie',
  defaultImage: 'd_defaults:d_serie.png'
}
cloudinary[imageTypes.SupplierProduct] = {
  typeFolder: 'supplierProduct',
  defaultImage: 'd_defaults:d_product.png'
}
cloudinary[imageTypes.OwnBrand] = {
  typeFolder: 'ownBrand',
  defaultImage: 'd_defaults:d_brand.png'
}
cloudinary[imageTypes.OwnSerie] = {
  typeFolder: 'ownSerie',
  defaultImage: 'd_defaults:d_serie.png'
}
cloudinary[imageTypes.OwnProduct] = {
  typeFolder: 'ownProduct',
  defaultImage: 'd_defaults:d_product.png'
}

function removeLastComma (str) {
  return str.replace(/,(\s+)?$/, '')
}

export default {
  props: {
    id: {
      required: true
    },
    type: {
      required: true,
      type: [Number, String]
    },
    imageVersion: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    transform: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: 'jpg'
    },
    campaign: {
      required: true
    },
    contain: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: [Number, String],
      default: undefined
    }
  },
  components:{
    Poster
  },
  computed: {
    cloudinaryUrl () {
      let config = this.$store.getters['app/getConfig']
      return `//res.cloudinary.com/${window.CONFIG.cloudinaryCloudName}/image/upload`
    },
    config(){
      return this.campaign.imageConfig
    },
    src () {
      let isOriginal = this.type < 0
      let imageType = Math.abs(this.type)
      let folder = cloudinary[imageType].typeFolder
      if (isOriginal) folder += ORIGINAL_IMAGE_POSTFIX
      let transform = this.transform ? removeLastComma(this.transform) + ',' + cloudinary[imageType].defaultImage : cloudinary[imageType].defaultImage
      let imageVersion = this.imageVersion > 0 ? `/v${this.imageVersion}` : ''
      return this.cloudinaryUrl + `/${transform}${imageVersion}/${folder}/${this.id}.${this.fileType}`
    }
  }
}
</script>

<style>

</style>
